import React, { useMemo, useRef, useEffect } from 'react';
import { useWebRTC } from '../../hooks/useWebRTC';

export type CallModalProps = {
  open: boolean;
  onClose: () => void;
  callerId: string;
  calleeId: string;
  type: 'audio' | 'video';
  isCaller?: boolean;
  callId?: string;
};

export default function CallModal(props: CallModalProps) {
  const { open, onClose, callerId, calleeId, type, isCaller = true, callId } = props;
  const { localStream, remoteStream, hangup } = useWebRTC({ callerId, calleeId, type, isCaller, callId });

  const localVideoProps = useMemo(() => ({ autoPlay: true, muted: true, playsInline: true }), []);
  const remoteVideoProps = useMemo(() => ({ autoPlay: true, playsInline: true }), []);
  const localVideoRef = useRef<HTMLVideoElement>(null);
  const remoteVideoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (localVideoRef.current && localStream) {
      (localVideoRef.current as any).srcObject = localStream;
      localVideoRef.current.play?.();
    }
    if (remoteVideoRef.current && remoteStream) {
      (remoteVideoRef.current as any).srcObject = remoteStream;
      remoteVideoRef.current.play?.();
    }
  }, [localStream, remoteStream]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center">
      <div className="bg-white w-full max-w-md rounded-lg shadow-lg p-4">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-lg font-semibold capitalize">{type} call</h2>
          <button
            className="px-3 py-1 rounded bg-red-500 text-white"
            onClick={() => {
              hangup();
              onClose();
            }}
          >End</button>
        </div>
        {type === 'video' ? (
          <div className="flex flex-col gap-3">
            <div className="rounded overflow-hidden bg-black">
              <video ref={remoteVideoRef} {...remoteVideoProps} className="w-full h-48 object-contain" />
            </div>
            <div className="rounded overflow-hidden bg-black">
              <video ref={localVideoRef} {...localVideoProps} className="w-full h-32 object-contain" />
            </div>
          </div>
        ) : (
          <div className="flex flex-col gap-3">
            <div className="text-center text-gray-700">Audio call connected</div>
          </div>
        )}
      </div>
    </div>
  );
}